import DashboardHeader from "./dashboardHeader";
import Fullscreen from "@/views/components/Fullscreen";
import AddMemberCustomerAnalysis from "./lianyunUser/addMemberCustomerAnalysis";
import AddMemberCustomerStatistic from "./lianyunUser/addMemberCustomerStatistic";
import AddMemberRevenueAnalysis from "./lianyunUser/addMemberRevenueAnalysis";
import AddRegisteredCustomerAnalysis from "./lianyunUser/addRegisteredCustomerAnalysis";
import CustomerConvertAnalysis from "./lianyunUser/customerConvertAnalysis";
import MemberCustomerStatistic from "./lianyunUser/memberCustomerStatistic";
import MemberRevenueStatistic from "./lianyunUser/memberRevenueStatistic";
import RegisteredCustomerStatistic from "./lianyunUser/registeredCustomerStatistic";

/** 链云用户看板，保持旧 Vue 看板的卡片分区、尺寸关系和滚动容器。 */
export default function LianYunUserDashboard() {
    return (
        <div id="dashboard" className="dashboard not-side lianyun-dashboard">
            {/* 旧版用户看板在页眉右侧提供独立于全局导航的看板全屏入口。 */}
            <Fullscreen targetId="dashboard" />
            <div className="dashboard-nav">
                <DashboardHeader />
            </div>
            <div className="dashboard-main">
                <div className="lian-yun-user">
                    <div className="card-1">
                        <RegisteredCustomerStatistic />
                        <div className="sep-line" />
                        <AddRegisteredCustomerAnalysis />
                    </div>
                    <div className="dashboard-card-row">
                        <div className="card-2">
                            <div className="card-2-left">
                                <MemberCustomerStatistic />
                            </div>
                            <div className="sep-line" />
                            <div className="card-2-right">
                                <AddMemberCustomerStatistic />
                                <AddMemberCustomerAnalysis />
                            </div>
                        </div>
                        <div className="card-3">
                            <CustomerConvertAnalysis />
                        </div>
                    </div>
                    <div className="card-4">
                        <div className="card-4-left">
                            <MemberRevenueStatistic />
                        </div>
                        <div className="sep-line" />
                        <AddMemberRevenueAnalysis />
                    </div>
                </div>
            </div>
        </div>
    );
}
